var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("b-modal", {
    attrs: { id: "customIdModal" },
    on: { ok: _vm.onConfirm },
    scopedSlots: _vm._u([
      {
        key: "default",
        fn: function() {
          return [
            _c("b-col", [
              _c("label", { attrs: { for: "config-CustomId" } }, [
                _vm._v("Custom ID:")
              ])
            ]),
            _vm._v(" "),
            _c(
              "b-col",
              [
                _c("b-form-input", {
                  attrs: { id: "config-CustomId", size: "sm", type: "text" },
                  model: {
                    value: _vm.customId,
                    callback: function($$v) {
                      _vm.customId = typeof $$v === "string" ? $$v.trim() : $$v
                    },
                    expression: "customId"
                  }
                })
              ],
              1
            )
          ]
        },
        proxy: true
      },
      {
        key: "modal-footer",
        fn: function() {
          return [
            _c(
              "b-col",
              { staticClass: "mr-2" },
              [
                _c(
                  "b-button",
                  {
                    attrs: { variant: "success" },
                    on: { click: _vm.onCancel }
                  },
                  [_vm._v("\n        Use default\n      ")]
                ),
                _vm._v(" "),
                _c(
                  "b-button",
                  {
                    attrs: { disabled: !_vm.allowSave },
                    on: { click: _vm.onConfirm }
                  },
                  [_vm._v("\n        Save custom ID\n      ")]
                )
              ],
              1
            )
          ]
        },
        proxy: true
      }
    ]),
    model: {
      value: _vm.show,
      callback: function($$v) {
        _vm.show = $$v
      },
      expression: "show"
    }
  })
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }